import { motion, useReducedMotion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 24 }) => {
  const reduce = useReducedMotion();
  return (
    <motion.div
      className={className}
      initial={reduce ? false : { opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
};

export const Overline = ({ children }) => (
  <p className="icon-overline inline-flex items-center gap-3 text-xs font-semibold uppercase tracking-[0.25em] text-cyan-300">
    <span className="h-px w-8 bg-gradient-to-r from-cyan-300 to-transparent" />
    {children}
  </p>
);
